import { isEmpty } from 'lodash';

import {
    REQUEST_UPDATE_INTERESTS,
    SUCCESS_UPDATE_INTERESTS,
    FAILURE_UPDATE_INTERESTS,
    RESET_FORM_SUBMIT_UPDATE_INTERESTS,
    REQUEST_USER_CRITERIA,
    RECEIVE_USER_CRITERIA,
    FAILURE_USER_CRITERIA
} from './constants';
import { CALL_API } from '../../../middlewares/api';
import { makeActionCreator } from '../../../utils/actionsUtils';
import { HTTP_METHOD_PUT } from '../../../constants/httpMethod';

export const reset = makeActionCreator(RESET_FORM_SUBMIT_UPDATE_INTERESTS);

export const sendInterestsUpdateRequestAndFetchUserCriteria = (
    formData,
    criteriaType,
    callback
) => dispatch =>
    dispatch(sendInterestsUpdateRequest(formData, criteriaType, callback)).then(() =>
        dispatch(fetchUserCriteriaIfNeeded(criteriaType, true))
    );

export const ERROR_FORMDATA_EMPTY =
    '[myinterests][sendInterestsUpdateRequest]formData param must not be empty or null or undefined !';

export function sendInterestsUpdateRequest(formData, criteriaType, callback) {
    if (isEmpty(formData)) {
        throw new Error(ERROR_FORMDATA_EMPTY);
    }
    return {
        [CALL_API]: {
            endpoint: `/user/criteria?type=${criteriaType}`,
            method: HTTP_METHOD_PUT,
            types: [REQUEST_UPDATE_INTERESTS, SUCCESS_UPDATE_INTERESTS, FAILURE_UPDATE_INTERESTS],
            body: formData,
            successCallback: () => {
                if (callback) {
                    callback();
                }
            }
        }
    };
}

const shouldFetchUserCriteria = (state, criteriaType) => {
    const usercriteria = state.account.myinterests.usercriteria[criteriaType];
    const fetching = state.account.myinterests.fetching;

    if (fetching) {
        return false;
    } else if (isEmpty(usercriteria)) {
        return true;
    } else {
        return false;
    }
};

export function fetchUserCriteriaIfNeeded(criteriaType, forceFetch = false) {
    return {
        [CALL_API]: {
            endpoint: `/user/criteria?type=${criteriaType}`,
            types: [REQUEST_USER_CRITERIA, RECEIVE_USER_CRITERIA, FAILURE_USER_CRITERIA],
            shouldCallAPI: state => forceFetch || shouldFetchUserCriteria(state, criteriaType),
            payload: { criteriaType },
            authenticated: true
        }
    };
}



// WEBPACK FOOTER //
// ./src/services/account/myinterests/actions.js